import { Component, Input, OnInit, inject } from '@angular/core';
import {Store} from '@ngxs/store';
import {UploadedFile} from '@app/_models/uploaded-file.model';
import {SettingsState} from '@app/_state/settings.state';
import {CommonModule} from '@angular/common';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzImageModule, NzImageService} from 'ng-zorro-antd/image';
import {NzGridModule} from 'ng-zorro-antd/grid';
import {NzIconDirective} from 'ng-zorro-antd/icon';
import {getFileDownloadUrl} from '@app/_utils/file-util';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NzModalService } from "ng-zorro-antd/modal";
import { PdfViewModalComponent } from "@app/project/_dialogs/pdf-view-modal/pdf-view-modal.component";

@Component({
    selector: 'app-file-download-link',
    template: `
    @if (file) {
      <nz-row nzAlign="middle" nzJustify="start" nzGutter="4">
        <nz-col>
          @if (preview && isFileImage()) {
            <button nz-button nzType="link" (click)="previewImage()">{{ file.name }}</button>
          } @else if (preview && isFilePDF()) {
            <button nz-button nzType="link" (click)="togglePdfViewer()">{{ file.name }}</button>
          } @else if (preview) {
            <a nz-button nzType="link" [href]="viewerUrl" target="_blank">{{ file.name }}</a>
          } @else {
            <a nz-button nzType="link" [href]="downloadUrl" target="_blank" rel="noopener noreferrer">{{ file.name }}</a>
          }
        </nz-col>
        <nz-col>
          <nz-row nzAlign="middle" nzJustify="end" nzGutter="4">
            @if (preview && isFileImage()) {
              <nz-col>
                <a nz-button nzType="dashed" nzSize="small" (click)="previewImage()">
                  <i nz-icon nzTheme="outline" nzType="eye"></i>
                </a>
              </nz-col>
            } @else if (preview && isFilePDF()) {
              <nz-col>
                <a nz-button nzType="dashed" nzSize="small" (click)="showPDFmodal(downloadUrl, file.name)">
                  <i nz-icon nzTheme="outline" nzType="eye"></i>
                </a>
              </nz-col>
            } @else if (preview) {
              <nz-col>
                <a nz-button nzType="dashed" nzSize="small" [href]="viewerUrl" target="_blank">
                  <i nz-icon nzTheme="outline" nzType="eye"></i>
                </a>
              </nz-col>
            }
            <nz-col>
              <a nz-button nzType="dashed" nzSize="small" [href]="downloadUrl" target="_blank" rel="noopener noreferrer">
                <i nz-icon nzTheme="outline" nzType="download"></i>
              </a>
            </nz-col>
          </nz-row>
        </nz-col>
      </nz-row>
    }
  `,
  imports: [
    CommonModule,
    NzGridModule,
    NzButtonModule,
    NzImageModule,
    NzIconDirective,
    PdfViewerModule
  ]
})
export class FileDownloadLinkComponent implements OnInit {
  private store = inject(Store);
  private nzImageService = inject(NzImageService);
  private modal = inject(NzModalService);

  @Input()
  file?: UploadedFile;

  @Input()
  preview = true;

  @Input()
  viewer = 'google'; // office || google

  downloadUrl?: string;
  viewerUrl?: string;
  isPDFVisible = false;

  googleUrl = `https://docs.google.com/gview?url=%URL%&embedded=true`;
  officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=%URL%`;

  ngOnInit(): void {
    if (this.file && this.file.id) {
      const authToken = this.store.selectSnapshot(SettingsState.token);
      this.downloadUrl = getFileDownloadUrl(this.file!.id);
      this.googleUrl = this.googleUrl.replace('%URL%', this.downloadUrl);
      this.officeUrl = this.officeUrl.replace('%URL%', this.downloadUrl);
      this.viewerUrl = this.viewer === 'office' ? this.officeUrl : this.googleUrl;
    }
  }

  isFileImage() {
    return this.file && this.file.contentType && this.file.contentType.split('/')[0] === 'image';
  }

  isFilePDF() {
    return this.file && this.file.contentType && this.file.contentType.includes('application/pdf');
  }

  previewImage(): void {
    if (this.downloadUrl) {
      const images = [
        { src: this.downloadUrl, alt: this.file?.name }
      ];
      this.nzImageService.preview(images, { nzZoom: 1, nzRotate: 0, nzScaleStep: 1 });
    }
  }

  showPDFmodal(url: string | undefined, name: string): void {
    const dialogRef = this.modal.create<PdfViewModalComponent, string>({
      nzTitle: name,
      nzContent: PdfViewModalComponent,
      nzData: url,
      nzWidth: '70rem',
      nzBodyStyle: {
        height: '90vh',
      },
      nzStyle: {
        top: '0',
      }
    });
    dialogRef.afterClose.asObservable().subscribe(result => {
      console.log(result);
    })
  }

  togglePdfViewer(): void {
    this.isPDFVisible = !this.isPDFVisible;
  }
}
